// Template: Add your feature flag here
// export const YOUR_FLAG_NAME_COOKIE_KEY = 'yourFlagName';
export const MATCHA_ACCOUNT = 'matcha-account';
export const HOMEPAGE_REVAMP = 'homepage-revamp';

/// List of supported feature flags.
export const SUPPORTED_FEATURE_FLAGS: string[] = [
  // feature flags here
  // YOUR_FLAG_NAME_COOKIE_KEY,
  MATCHA_ACCOUNT,
  HOMEPAGE_REVAMP,
];
